import React, {FC, useMemo} from 'react';
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../core";

export const BookmarksIcon: FC = () => {

    const is1440BP = useBreakpoint(LayoutConst.screen.mac13);
    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);

    if (!is1440BP && !smHeight) return <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M11.4287 6.9001C10.0968 6.9001 8.9001 8.08914 8.9001 9.70598V24.854L16.0001 17.8774L23.1001 24.854V9.70598C23.1001 8.08914 21.9034 6.9001 20.5715 6.9001H11.4287ZM7.1001 9.70598C7.1001 7.22942 8.97343 5.1001 11.4287 5.1001H20.5715C23.0268 5.1001 24.9001 7.22942 24.9001 9.70598V29.1462L16.0001 20.4009L7.1001 29.1462V9.70598Z" fill="#909090"/>
    </svg>

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8 3.5C6.64583 3.5 5.5 4.67099 5.5 6.17647V19.8247L12 13.568L18.5 19.8247V6.17647C18.5 4.67099 17.3542 3.5 16 3.5H8ZM4.5 6.17647C4.5 4.17332 6.04046 2.5 8 2.5H16C17.9595 2.5 19.5 4.17332 19.5 6.17647V22.1753L12 14.956L4.5 22.1753V6.17647Z" fill="#909090"/>
        </svg>
    )
}

import React, {FC, useMemo} from 'react';
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../core";

export const BookmarksIcon: FC = () => {

    const is1440BP = useBreakpoint(LayoutConst.screen.mac13);
    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);

    if (!is1440BP && !smHeight) return <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M11.4287 6.9001C10.0968 6.9001 8.9001 8.08914 8.9001 9.70598V24.854L16.0001 17.8774L23.1001 24.854V9.70598C23.1001 8.08914 21.9034 6.9001 20.5715 6.9001H11.4287ZM7.1001 9.70598C7.1001 7.22942 8.97343 5.1001 11.4287 5.1001H20.5715C23.0268 5.1001 24.9001 7.22942 24.9001 9.70598V29.1462L16.0001 20.4009L7.1001 29.1462V9.70598Z" fill="#909090"/>
    </svg>

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8 3.5C6.64583 3.5 5.5 4.67099 5.5 6.17647V19.8247L12 13.568L18.5 19.8247V6.17647C18.5 4.67099 17.3542 3.5 16 3.5H8ZM4.5 6.17647C4.5 4.17332 6.04046 2.5 8 2.5H16C17.9595 2.5 19.5 4.17332 19.5 6.17647V22.1753L12 14.956L4.5 22.1753V6.17647Z" fill="#909090"/>
        </svg>
    )
}

